import cn from 'classnames'
import { useCallback, useMemo } from 'react'

import { useFormField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { Checkbox } from 'core-components/library/checkbox'
import { TFormRequestStatus } from 'partner360/features/topPartnersManagement/models'
import { TRANSLATION_KEYS } from 'partner360/features/topPartnersManagement/translations'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

import styles from './RequestsStatisticFilter.module.scss'

interface IMainInfoProps {
  partners: IPartnerWithFlagRequests[]
  field: string
  formKey: string
  defaultValue: TFormRequestStatus
}
export const RequestsStatisticFilter = ({
  partners,
  formKey,
  defaultValue,
  field,
}: IMainInfoProps) => {
  const { handleChange, value } = useFormField<TFormRequestStatus>({
    field,
    formKey,
    defaultValue,
  })

  const { all, wipReqs, newReqs } = useMemo(() => {
    const all = partners.filter((el) => el.RequestStatus === 'New' || el.RequestStatus === 'Wip')
    const wipReqs = all.filter((el) => el.RequestStatus === 'Wip')
    const newReqs = all.filter((el) => el.RequestStatus === 'New')

    return {
      all: all.length,
      wipReqs: wipReqs.length,
      newReqs: newReqs.length,
    }
  }, [partners])

  const onCheck = useCallback(
    (flag: boolean) => {
      if (flag) {
        handleChange('All')
      } else {
        handleChange(null)
      }
    },
    [handleChange]
  )

  const onSelect = useCallback(
    (status: TFormRequestStatus) => {
      handleChange(value === status ? null : status)
    },
    [handleChange, value]
  )

  return (
    <div className={styles.root}>
      <Checkbox
        checked={value != null}
        onChange={onCheck}
        label={<Translation span text={TRANSLATION_KEYS.topPartners.mainInfo.checkbox} />}
      />
      <div className={styles.list}>
        <div
          className={cn(styles.item, styles.all, {
            [styles.selected]: value === 'All',
          })}
          onClick={() => onSelect('All')}
        >
          <div className={styles.label}>
            <Translation span text={TRANSLATION_KEYS.topPartners.mainInfo.all} />
          </div>
          <div className={styles.count}>{all}</div>
        </div>

        <div
          className={cn(styles.item, styles.new, {
            [styles.selected]: value === 'New',
          })}
          onClick={() => onSelect('New')}
        >
          <div className={styles.label}>
            <Translation span text={TRANSLATION_KEYS.topPartners.mainInfo.new} />
          </div>
          <div className={styles.count}>{newReqs}</div>
        </div>

        <div
          className={cn(styles.item, styles.wip, {
            [styles.selected]: value === 'Wip',
          })}
          onClick={() => onSelect('Wip')}
        >
          <div className={styles.label}>
            <Translation span text={TRANSLATION_KEYS.topPartners.mainInfo.wip} />
          </div>
          <div className={styles.count}>{wipReqs}</div>
        </div>
      </div>
    </div>
  )
}
